import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "firesafety-Location-Red",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Location Red",
    description: "Location-Red",
    image: require("./Location-Red.svg"),
    svgIcon: require("./Location-Red.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g>
          <defs>
            <style>{`.locationredcls1{fill:#d71214;}`}</style>
          </defs>
          <g
            transform={`translate(-47, 55) scale(1, -1)`}
            id={`${element.type}-${element.id}`}
            data-name="corner shower"
          >
           <path class="locationredcls1" d="M49.41.81a36.06,36.06,0,0,1,7.38.76A36.47,36.47,0,0,1,62.38,3.2a35.19,35.19,0,0,1,5.85,2.86,36.6,36.6,0,0,1,3.28,2.25C72.37,9,73.19,9.67,74,10.4a28.45,28.45,0,0,1,2.42,2.49c.56.66,1.13,1.32,1.65,2s1.13,1.57,1.66,2.38a25.89,25.89,0,0,1,1.66,2.9,36.14,36.14,0,0,1,1.68,3.94c.31.87.55,1.76.81,2.65a33.83,33.83,0,0,1,.83,4.45,30.47,30.47,0,0,1,.22,5.48A31.93,31.93,0,0,1,84,43c-.22.91-.49,1.8-.79,2.69-.24.74-.52,1.47-.83,2.18-.52,1.16-1.07,2.31-1.63,3.44s-1.06,2-1.6,3-1.11,2-1.68,3-1.06,1.8-1.6,2.68-1.09,1.78-1.64,2.65-1.06,1.65-1.6,2.47-1.13,1.7-1.7,2.54L69.35,70l-2.51,3.51c-.52.72-1,1.43-1.58,2.13-.83,1.1-1.66,2.2-2.5,3.29-.52.69-1,1.36-1.59,2q-1.24,1.58-2.52,3.15c-.5.62-1,1.24-1.52,1.85-.84,1-1.69,2-2.55,3-.46.55-.93,1.09-1.4,1.62-.8.92-1.6,1.84-2.42,2.75a2,2,0,0,1-2.49.32,2.89,2.89,0,0,1-.59-.51c-1-1.12-2-2.25-2.94-3.38-.5-.57-1-1.14-1.48-1.72l-2.59-3.14c-.52-.62-1-1.25-1.53-1.88l-2.59-3.27c-.47-.6-.94-1.2-1.41-1.82-.88-1.17-1.77-2.35-2.64-3.53-.54-.72-1.08-1.45-1.6-2.19q-1.26-1.77-2.51-3.55c-.54-.78-1.07-1.56-1.6-2.35s-1.12-1.7-1.68-2.55-1.05-1.65-1.56-2.48-1.15-1.86-1.71-2.8-1.06-1.79-1.56-2.7c-.59-1.06-1.16-2.12-1.73-3.19-.22-.4-.44-.81-.64-1.23-.49-1-1-2-1.45-3a29.5,29.5,0,0,1-1.2-3.12c-.32-1-.55-1.94-.8-2.92a28.29,28.29,0,0,1-.7-4.77,33.46,33.46,0,0,1,0-5.39,26.73,26.73,0,0,1,.56-3.87c.22-1,.47-2,.76-2.92.23-.79.5-1.56.8-2.33a33.43,33.43,0,0,1,1.63-3.55c.51-.93,1.06-1.84,1.63-2.73a29.14,29.14,0,0,1,2.45-3.28c.79-.9,1.61-1.78,2.46-2.63a29.23,29.23,0,0,1,3.23-2.76c.82-.61,1.66-1.2,2.52-1.74a35,35,0,0,1,7-3.41A37,37,0,0,1,42.4,1.45,35.26,35.26,0,0,1,49.41.81ZM67.86,35.32a20.67,20.67,0,0,0-.32-3.25,18.91,18.91,0,0,0-.89-3.19A17.7,17.7,0,0,0,65,25.67a18.75,18.75,0,0,0-1.63-2.13,17.89,17.89,0,0,0-3.32-2.94,18.67,18.67,0,0,0-9-3.25,19.14,19.14,0,0,0-6,.39,18.73,18.73,0,0,0-10.3,6.35,16.17,16.17,0,0,0-1.62,2.33,17.7,17.7,0,0,0-1.68,3.93,14.86,14.86,0,0,0-.57,3.17,16.76,16.76,0,0,0,.78,7,17,17,0,0,0,.83,2.08,19.44,19.44,0,0,0,1.66,2.78A18.74,18.74,0,0,0,36.55,48a18.45,18.45,0,0,0,3.33,2.43A19.37,19.37,0,0,0,44,52.2a19,19,0,0,0,7.46.61,19.31,19.31,0,0,0,5.69-1.56,18.31,18.31,0,0,0,7.29-5.87A17.67,17.67,0,0,0,66,42.74c.3-.61.56-1.24.8-1.88a17.09,17.09,0,0,0,.79-3.15C67.77,36.86,67.8,36,67.86,35.32Z" transform="translate(-13.67 -0.8)"/>

          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
